<template>
  <b>Доставка</b>
  <br>
  Мы осуществляем курьерскую доставку во все города России. Также вы можете получить заказ в одном из пунктов выдачи заказов СДЭК. Уточнить стоимость доставки до вашего города можно у менеджера по телефону 8 (800) 555-27-48. С полными условиями доставки вы можете ознакомиться <router-link to="/page/dostavka/">здесь</router-link>.
  <br>
  <br>
  <b>Оплата</b>
  <br>
  Вы можете оплатить заказ наличными или банковской картой при получении, либо банковской картой онлайн. С полными условиями оплаты вы можете ознакомиться <router-link to="/page/oplata/" >здесь</router-link>.
</template>

<script>
export default {
  mounted() {

  },
  components: {},
  methods: {
  },
}
</script>

